// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ykCKa","content":"styles_content__1eprb","tableWrap":"styles_tableWrap__3-ZX5"};